export default __webpack_public_path__ + "static/media/image_triple_50.52608291.svg";